import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Intro from "../../../../../elements/blocks/intro";
import CustomFieldForm from "../../../../../elements/custom-fields/custom-field-form";
export default function FormFieldNew() {
    const { t } = useTranslation();
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: t("fields.shared-fields.form-fields.new-form-field"), breadcrumbs: [
                    {
                        name: t("settings"),
                        link: "/settings",
                    },
                    {
                        name: t("fields.fields"),
                        link: "/settings/fields",
                    },
                    {
                        name: t("fields.shared-fields.shared-fields"),
                        link: "/settings/fields/shared",
                    },
                    {
                        name: t("fields.shared-fields.form-fields.forms"),
                        link: "/settings/fields/shared/forms",
                    },
                    {
                        name: t("fields.new-field"),
                        link: "/settings/fields/shared/forms/new",
                    },
                ] }), _jsx(CustomFieldForm, { status: "new", type: "campaign_steps", shared: true })] }));
}
